import {TrackingEvent} from '@common/tracking-events'
import {LinkButtonSmall} from '@components/common/button/button'
import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {paymentDaysLeft} from 'yougile-model'
import {Time} from 'yougile-util'
import {Tracking} from '../../../../common/tracking'
import {PageService} from '../../../extensions/page-service'
import {useMainMenuStore} from '../main-menu-store'

const goToBilling = () => {
  void Tracking.send(TrackingEvent.billingLeftMenuFooterClick)
  PageService.goTo('billing')
}

const TwBanners = tw.div<{$expireSoon: boolean}>`
  ${p => (p.$expireSoon ? 'text-error' : 'text-grey')}
  leading-normal
  pt-8
  px-16
  pb-16
`

export const Banners = observer(() => {
  const [state] = useMainMenuStore()
  const {paymentStatus, showBilling, readonly, userRegisterTime} = state

  const showPayment =
    showBilling &&
    paymentDaysLeft(paymentStatus) <= 31 &&
    !readonly &&
    !(userRegisterTime > Time.now() - 24 * 3600_000)
  const daysLeft = paymentDaysLeft(paymentStatus)
  const onFree = !paymentStatus || daysLeft <= 0
  const onPaid = paymentStatus && paymentStatus.tariff !== 'trial' && !onFree
  const onStandalone = paymentStatus && paymentStatus.tariff === 'standalone'

  return !onStandalone && showPayment && onPaid && <BannersComponent />
})

const BannersComponent = observer(() => {
  const [state] = useMainMenuStore()
  const {paymentStatus, canSeeLicensesPage} = state
  const daysLeft = paymentDaysLeft(paymentStatus)
  return (
    <TwBanners $expireSoon={daysLeft < 20}>
      <div>
        <div className="text-12 text-grey inline-block">
          {Lang.msg.bill.licenseExpiresIn}{' '}
          <div className="inline font-semibold">
            {Lang.msg.severalDays(daysLeft)}
          </div>
          .{' '}
          {canSeeLicensesPage && (
            <LinkButtonSmall onClick={goToBilling}>
              {Lang.msg.billingProlong} {'»'}
            </LinkButtonSmall>
          )}
        </div>
      </div>
    </TwBanners>
  )
})
